module.exports = __webpack_public_path__ + "files/ac7b271020015dbb794baccc974ccbc5.png";